import type { MemorySuggestion } from '../../../hooks/useMemoryExtraction';

interface MemoryConfirmationProps {
  suggestion: MemorySuggestion;
  onConfirm: () => void;
  onSkip: () => void;
  onLater: () => void;
}

export function MemoryConfirmation({
  suggestion,
  onConfirm,
  onSkip,
  onLater,
}: MemoryConfirmationProps) {
  const getIcon = () => {
    if (suggestion.type === 'event') return '📅';
    if (suggestion.confidence >= 0.8) return '⭐';
    return '💭';
  };

  const getMessage = () => {
    if (suggestion.type === 'event') {
      return '大事な予定みたいですね。近くなったら声かけましょうか？';
    }
    if (suggestion.type === 'relation') {
      return 'これ、覚えておいてほしいですか？';
    }
    return 'これからも覚えておけるようにしておきますか？';
  };

  const getDisplayContent = () => {
    return suggestion.content;
  };

  return (
    <div className="bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-4 border border-teal-100 shadow-sm animate-fadeIn">
      <div className="flex items-start gap-3 mb-3">
        <span className="text-2xl flex-shrink-0">{getIcon()}</span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-700 mb-1">{getMessage()}</p>
          <p className="text-sm text-gray-600 bg-white/60 rounded-lg px-3 py-2 break-words">
            {getDisplayContent()}
          </p>
        </div>
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={onConfirm}
          className="flex-1 bg-teal-500 hover:bg-teal-600 text-white text-sm font-medium py-2 px-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
        >
          覚えておいて
        </button>
        <button
          onClick={onSkip}
          className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium py-2 px-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
        >
          今回だけ
        </button>
        <button
          onClick={onLater}
          className="flex-1 bg-white hover:bg-gray-50 text-gray-600 text-sm font-medium py-2 px-4 rounded-xl border border-gray-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          あとで決める
        </button>
      </div>
    </div>
  );
}